import { render, staticRenderFns } from "./ProductDescriptionLeaflet.vue?vue&type=template&id=574bf49a"
import script from "./ProductDescriptionLeaflet.vue?vue&type=script&lang=js"
export * from "./ProductDescriptionLeaflet.vue?vue&type=script&lang=js"
import style0 from "./ProductDescriptionLeaflet.vue?vue&type=style&index=0&id=574bf49a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports